import "bootstrap/dist/css/bootstrap.min.css"
import React, { useState, useEffect, useContext } from "react"
import Card from "@material-ui/core/Card"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import CardHeader from "@material-ui/core/CardHeader"
import newsLogo from "./static/news_logo_transparent.png"
import stLogo from "./static/stocktwits_logo_transparent.png"
import IconButton from "@material-ui/core/IconButton"
import GetAppIcon from "@material-ui/icons/GetApp"
import TableFooter from "@material-ui/core/TableFooter"
import axios from "axios"
import redditLogo from "./static/reddit_logo.png"
import blueskyLogo from "./static/bluesky.jpg"
import edgarLogo from "./static/edgar.svg"
import MenuItem from "@material-ui/core/MenuItem"
import Menu from "@material-ui/core/Menu"
import { NavLink, Route } from "react-router-dom"
import PersonIcon from "@material-ui/icons/Person"
import FilterListIcon from "@material-ui/icons/FilterList"
import Tooltip from "@material-ui/core/Tooltip"
import Snackbar from "@material-ui/core/Snackbar"
import SnackbarContent from "@material-ui/core/SnackbarContent"
import Table from "./common/Table"
import { WeightContext } from "../context/WeightProvider"
import api from "./api_ui"
import Pagination from "@material-ui/lab/Pagination"

const Tables = (props) => {
    const [anchorElST, setAnchorElST] = React.useState(null)
    const [anchorElNews, setAnchorElNews] = React.useState(null)
    const [anchorElReddit, setAnchorElReddit] = React.useState(null)
    const [anchorElBluesky, setAnchorElBluesky] = React.useState(null)
    const [anchorElEdgar, setAnchorElEdgar] = React.useState(null)
    const [newsList, setNewsList] = React.useState([])
    const [stList, setStList] = React.useState([])
    const [redditList, setRedditList] = React.useState([])
    const [blueskyList, setBlueskyList] = React.useState([])
    const [edgarList, setEdgarList] = React.useState([])
    
    // Pagination state variables
    const [newsCurrentPage, setNewsCurrentPage] = React.useState(1)
    const [stCurrentPage, setStCurrentPage] = React.useState(1)
    const [redditCurrentPage, setRedditCurrentPage] = React.useState(1)
    const [blueskyCurrentPage, setBlueskyCurrentPage] = React.useState(1)
    const [edgarCurrentPage, setEdgarCurrentPage] = React.useState(1)
    const [itemsPerPage] = React.useState(100)
    const [isLoadingScroll, setIsLoadingScroll] = React.useState(false)

    const [sortST, setSortST] = React.useState(null)
    const [sortNews, setSortNews] = React.useState(null)
    const [sortReddit, setSortReddit] = React.useState(null)
    const [sortBluesky, setSortBluesky] = React.useState(null)
    const [sortEdgar, setSortEdgar] = React.useState(null)
    const [newsScroll, setNewsScroll] = React.useState(null)
    const [selectedIndexST, setSelectedIndexST] = React.useState(0)
    const [selectedIndexNews, setSelectedIndexNews] = React.useState(0)
    const [selectedIndexReddit, setSelectedIndexReddit] = React.useState(0)
    const [selectedIndexBluesky, setSelectedIndexBluesky] = React.useState(0)
    const [selectedIndexEdgar, setSelectedIndexEdgar] = React.useState(0)
    const { weights } = useContext(WeightContext)

    const [newsCount, setNewsCount] = React.useState({
        positive: 0,
        negative: 0,
        neutral: 0,
        total: 0
    })

    const [stCount, setStCount] = React.useState({
        positive: 0,
        negative: 0,
        neutral: 0,
        total: 0
    })

    const [redditCount, setRedditCount] = React.useState({
        positive: 0,
        negative: 0,
        neutral: 0,
        total: 0
    })

    const [blueskyCount, setBlueskyCount] = React.useState({
        positive: 0,
        negative: 0,
        neutral: 0,
        total: 0
    })

    const [edgarCount, setEdgarCount] = React.useState({
        positive: 0,
        negative: 0,
        neutral: 0,
        total: 0
    })

    const [alertState, setAlertState] = React.useState({
        open: false,
        vertical: "top",
        horizontal: "center",
        message: "",
        contentStyle: null
    })

    const [prevAlert, setPrevAlert] = React.useState({
        Stocktwits: 0,
        News: 0
    })
    const { vertical, horizontal, alertOpen } = alertState

    // Add a state to track when scroll loading is complete
    const [scrollLoadingComplete, setScrollLoadingComplete] = React.useState(false)

    const checkAlert = (src, val) => {
        if ((val > 10000) & (prevAlert[src] !== val) & !props.Run) {
            setAlertState((prevState) => {
                return {
                    ...prevState,
                    contentStyle: {
                        backgroundColor: "#008080",
                        fontSize: 18,
                        marginTop: "20%"
                    },
                    alertOpen: true,
                    message:
                        src +
                        " has surpased the limit of 10,000 documents. Please select a smaller date range."
                }
            })
            if (src === "News") {
                setPrevAlert((prevState) => {
                    return { ...prevState, News: val }
                })
            } else {
                setPrevAlert((prevState) => {
                    return { ...prevState, Stocktwits: val }
                })
            }
        }
    }

    const handleMenuST = (event) => {
        setAnchorElST(event.currentTarget)
    }

    const handleCloseST = () => {
        setAnchorElST(null)
    }
    const handleMenuNews = (event) => {
        setAnchorElNews(event.currentTarget)
    }

    const handleCloseNews = () => {
        setAnchorElNews(null)
    }

    const handleMenuReddit = (event) => {
        setAnchorElReddit(event.currentTarget)
    }

    const handleCloseReddit = () => {
        setAnchorElReddit(null)
    }

    const handleMenuBluesky = (event) => {
        setAnchorElBluesky(event.currentTarget)
    }

    const handleCloseBluesky = () => {
        setAnchorElBluesky(null)
    }

    const handleMenuEdgar = (event) => {
        setAnchorElEdgar(event.currentTarget)
    }

    const handleCloseEdgar = () => {
        setAnchorElEdgar(null)
    }

    const handleAlertClose = () => {
        setAlertState({ ...alertState, alertOpen: false })
    }

    // Page change handlers
    const handleNewsPageChange = (event, value) => {
        setNewsCurrentPage(value)
    }

    const handleStPageChange = (event, value) => {
        setStCurrentPage(value)
    }

    const handleRedditPageChange = (event, value) => {
        setRedditCurrentPage(value)
    }

    const handleBlueskyPageChange = (event, value) => {
        setBlueskyCurrentPage(value)
    }

    const handleEdgarPageChange = (event, value) => {
        setEdgarCurrentPage(value)
    }

    const quickBorder = (score) => {
        if (score > 0) {
            return "solid rgb(59, 136, 63) 6px"
        } else if (score < 0) {
            return "solid rgb(202, 59, 51) 6px"
        } else {
            return "solid rgb(248, 204, 71) 6px"
        }
    }

    const setSTValues = () => {
        if (props.stocktwitsData) {
            if (props.stocktwitsData.count) {
                checkAlert("Stocktwits", props.stocktwitsData.data.title.total)

                setStCount(() => {
                    return {
                        positive: props.stocktwitsData.count.positive,
                        negative: props.stocktwitsData.count.negative,
                        neutral: props.stocktwitsData.count.neutral,
                        total: props.stocktwitsData.data.title.total
                    }
                })
            }
        }
    }

    const setNewsValues = () => {
        if (props.newsData) {
            if (props.newsToggle === "title") {
                if (props.newsData.count && props.newsData.data.title) {
                    checkAlert("News", props.newsData.data.title.total)

                    setNewsCount(() => {
                        return {
                            positive: props.newsData.count.positive,
                            negative: props.newsData.count.negative,
                            neutral: props.newsData.count.neutral,
                            total: props.newsData.data.title.total
                        }
                    })
                }
            } else {
                if (props.newsData.count_text && props.newsData.data.text) {
                    checkAlert("News", props.newsData.data.text.total)
                    setNewsCount(() => {
                        return {
                            positive: props.newsData.count_text.positive,
                            negative: props.newsData.count_text.negative,
                            neutral: props.newsData.count_text.neutral,
                            total: props.newsData.data.text.total
                        }
                    })
                }
            }
        }
    }

    const setRedditValues = () => {
        if (props.redditData) {
            if (props.redditData.count) {
                checkAlert("reddit", props.redditData.data.title.total)

                setRedditCount(() => {
                    return {
                        positive: props.redditData.count.positive,
                        negative: props.redditData.count.negative,
                        neutral: props.redditData.count.neutral,
                        total: props.redditData.data.title.total
                    }
                })
            }
        }
    }

    const setBlueskyValues = () => {
        if (props.blueskyData) {
            if (props.blueskyData.count) {
                checkAlert("bluesky", props.blueskyData.data.title.total)

                setBlueskyCount(() => {
                    return {
                        positive: props.blueskyData.count.positive,
                        negative: props.blueskyData.count.negative,
                        neutral: props.blueskyData.count.neutral,
                        total: props.blueskyData.data.title.total
                    }
                })
            }
        }
    }

    const setEdgarValues = () => {
        if (props.edgarData) {
            if (props.edgarData.count) {
                checkAlert("edgar", props.edgarData.data.title.total)

                setEdgarCount(() => {
                    return {
                        positive: props.edgarData.count.positive,
                        negative: props.edgarData.count.negative,
                        neutral: props.edgarData.count.neutral,
                        total: props.edgarData.data.title.total
                    }
                })
            }
        }
    }

    const getSortData = (source, sortby, ascending) => {
        if (source === "Stocktwits") {
            setStCurrentPage(1) // Reset to first page
            if (sortby === "Date") {
                stList.title.data.sort((a, b) =>
                    ascending
                        ? new Date(a.Created_at2) - new Date(b.Created_at2)
                        : new Date(b.Created_at2) - new Date(a.Created_at2)
                )
                setSelectedIndexST(() => {
                    return 1
                })
            } else if (sortby === "Sentiment") {
                if (props.DQToggle === "DQ_sentiment") {
                    stList.title.data.sort((a, b) =>
                        ascending
                            ? a.DQ_sentiment - b.DQ_sentiment
                            : b.DQ_sentiment - a.DQ_sentiment
                    )
                    setSelectedIndexST(() => {
                        return 2
                    })
                } else {
                    stList.title.data.sort((a, b) =>
                        ascending
                            ? a.Sentiment_score - b.Sentiment_score
                            : b.Sentiment_score - a.Sentiment_score
                    )
                    setSelectedIndexST(() => {
                        return 2
                    })
                }
            } else {
                stList.title.data.sort((a, b) =>
                    ascending
                        ? a.rev_score - b.rev_score
                        : b.rev_score - a.rev_score
                )
                setSelectedIndexST(() => {
                    return 0
                })
            }
        } else if (source === "News") {
            setNewsCurrentPage(1) // Reset to first page
            if (props.newsToggle === "text") {
                if (sortby === "Date") {
                    newsList.text.data.sort((a, b) =>
                        ascending
                            ? new Date(a.Created_at2) - new Date(b.Created_at2)
                            : new Date(b.Created_at2) - new Date(a.Created_at2)
                    )
                    setSelectedIndexNews(() => {
                        return 1
                    })
                } else if (sortby === "Sentiment") {
                    newsList.text.data.sort((a, b) =>
                        ascending
                            ? a.Sentiment_score_text - b.Sentiment_score_text
                            : b.Sentiment_score_text - a.Sentiment_score_text
                    )
                    setSelectedIndexNews(() => {
                        return 2
                    })
                } else {
                    newsList.text.data.sort((a, b) =>
                        ascending
                            ? a.rev_score - b.rev_score
                            : b.rev_score - a.rev_score
                    )
                    setSelectedIndexNews(() => {
                        return 0
                    })
                }
            } else {
                if (sortby === "Date") {
                    newsList.title.data.sort((a, b) =>
                        ascending
                            ? new Date(a.Created_at2) - new Date(b.Created_at2)
                            : new Date(b.Created_at2) - new Date(a.Created_at2)
                    )
                    setSelectedIndexNews(() => {
                        return 1
                    })
                } else if (sortby === "Sentiment") {
                    newsList.title.data.sort((a, b) =>
                        ascending
                            ? a.Sentiment_score - b.Sentiment_score
                            : b.Sentiment_score - a.Sentiment_score
                    )
                    setSelectedIndexNews(() => {
                        return 2
                    })
                } else {
                    newsList.title.data.sort((a, b) => {
                        return b.rev_score - a.rev_score
                    })
                    setSelectedIndexNews(() => {
                        return 0
                    })
                }
            }
        } else if (source === "Reddit") {
            setRedditCurrentPage(1) // Reset to first page
            if (sortby === "Date") {
                redditList.title.data.sort((a, b) =>
                    ascending
                        ? new Date(a.Created_at2) - new Date(b.Created_at2)
                        : new Date(b.Created_at2) - new Date(a.Created_at2)
                )
                setSelectedIndexReddit(() => {
                    return 1
                })
            } else if (sortby === "Sentiment") {
                if (props.DQToggle === "DQ_sentiment") {
                    redditList.title.data.sort((a, b) =>
                        ascending
                            ? a.DQ_sentiment - b.DQ_sentiment
                            : b.DQ_sentiment - a.DQ_sentiment
                    )
                    setSelectedIndexReddit(() => {
                        return 2
                    })
                } else {
                    redditList.title.data.sort((a, b) =>
                        ascending
                            ? a.fsai_Sentiment_score - b.fsai_Sentiment_score
                            : b.fsai_Sentiment_score - a.fsai_Sentiment_score
                    )
                    setSelectedIndexReddit(() => {
                        return 2
                    })
                }
            } else {
                redditList.title.data.sort((a, b) =>
                    ascending
                        ? a.rev_score - b.rev_score
                        : b.rev_score - a.rev_score
                )
                setSelectedIndexReddit(() => {
                    return 0
                })
            }
        } else if (source === "Bluesky") {
            setBlueskyCurrentPage(1) // Reset to first page
            if (sortby === "Date") {
                blueskyList.title.data.sort((a, b) =>
                    ascending
                        ? new Date(a.Created_at2) - new Date(b.Created_at2)
                        : new Date(b.Created_at2) - new Date(a.Created_at2)
                )
                setSelectedIndexBluesky(() => {
                    return 1
                })
            } else if (sortby === "Sentiment") {
                if (props.DQToggle === "DQ_sentiment") {
                    blueskyList.title.data.sort((a, b) =>
                        ascending
                            ? a.DQ_sentiment - b.DQ_sentiment
                            : b.DQ_sentiment - a.DQ_sentiment
                    )
                    setSelectedIndexBluesky(() => {
                        return 2
                    })
                } else {
                    blueskyList.title.data.sort((a, b) =>
                        ascending
                            ? a.Sentiment_score - b.Sentiment_score
                            : b.Sentiment_score - a.Sentiment_score
                    )
                    setSelectedIndexBluesky(() => {
                        return 2
                    })
                }
            } else {
                blueskyList.title.data.sort((a, b) =>
                    ascending
                        ? a.rev_score - b.rev_score
                        : b.rev_score - a.rev_score
                )
                setSelectedIndexBluesky(() => {
                    return 0
                })
            }
        } else if (source === "Edgar") {
            setEdgarCurrentPage(1) // Reset to first page
            if (sortby === "Date") {
                edgarList.title.data.sort((a, b) =>
                    ascending
                        ? new Date(a.filed_at) - new Date(b.filed_at)
                        : new Date(b.filed_at) - new Date(a.filed_at)
                )
                setSelectedIndexEdgar(() => {
                    return 1
                })
            } else if (sortby === "Sentiment") {
                edgarList.title.data.sort((a, b) =>
                    ascending
                        ? a.fsai_sentiment_score - b.fsai_sentiment_score
                        : b.fsai_sentiment_score - a.fsai_sentiment_score
                )
                setSelectedIndexEdgar(() => {
                    return 2
                })
            } else {
                edgarList.title.data.sort((a, b) =>
                    ascending
                        ? a.rev_score - b.rev_score
                        : b.rev_score - a.rev_score
                )
                setSelectedIndexEdgar(() => {
                    return 0
                })
            }
        }
    }

    const stTableVals = (row) => {
        return (
            <div
                className='pl-3 pb-0 mb-2'
                style={{
                    borderLeft: quickBorder(parseFloat(row[props.DQToggle])),
                    paddingLeft: 10
                }}>
                <h5
                    style={{
                        fontWeight: 700,
                        color: "rgb(0, 99, 158)",
                        marginBottom: 3
                    }}>
                    {row.Keyword
                        ? row.Keyword.map((word) => word.text).join(" ")
                        : ""}
                </h5>
                <a
                    style={{
                        marginBottom: 3,
                        fontSize: 20,
                        color: "black",
                        textDecoration: "none"
                    }}>
                    {row.Body}
                </a>
                <br></br>
                <br></br>
                <div
                    className='row mt-1'
                    style={{ fontSize: 16, color: "rgb(200, 154, 93)" }}>
                    <p className='col-4'>{row.Created_at2 + "(ET)"}</p>
                    <p className='col-4 ml-auto mr-auto'>
                        <b>Relevance: </b>
                        {row.rev_score.toFixed(3)}
                    </p>
                    <div className='col-4 ml-auto'>
                        <p>
                            <b>Sentiment score:</b>{" "}
                            {row.Sentiment_score.toFixed(3)}
                        </p>
                    </div>
                </div>
            </div>
        )
    }

    const getStocktwits = () => {
        let rows = (
            <h5 style={{ color: "#adb5bd" }}>Run a Query to Load Data</h5>
        )
        try {
            if (stList && stList.title && stList.title.data.length > 0) {
                const maxItems = 600
                const limitedData = stList.title.data.slice(0, maxItems)
                const startIndex = (stCurrentPage - 1) * itemsPerPage
                const endIndex = startIndex + itemsPerPage
                const paginatedData = limitedData.slice(startIndex, endIndex)
                
                rows = paginatedData.map((row, pos) => stTableVals(row))
            }
        } catch (err) {
            console.log(err)
        }
        return <div>{rows}</div>
    }

    const redditTableVals = (row) => {
        if (!row) return null

        // Helper function to safely extract text from potentially nested objects
        const extractText = (value) => {
            if (value === null || value === undefined) return null
            if (typeof value === 'string') return value
            if (typeof value === 'object') {
                // Try common text properties
                return value.text || value.Text || value.content || value.Content || 
                       value.body || value.Body || value.message || value.Message ||
                       JSON.stringify(value) // Last resort
            }
            return String(value)
        }

        // Determine sentiment score based on available properties - similar to news
        let sentimentScore = null
        sentimentScore = row[props.DQToggle] || 
                        row.fsai_sentiment_score || 
                        row.sentiment_score || 
                        row.Sentiment_score ||
                        row.fsai_Sentiment_score

        // If still null, try other common properties
        if (sentimentScore === null || sentimentScore === undefined) {
            sentimentScore = row.DQ_sentiment || 
                            row.dq_sentiment
        }

        // Determine keyword based on available properties - enhanced like news
        let temp = null
        if (row.fsai_Keywords && Array.isArray(row.fsai_Keywords)) {
            temp = row.fsai_Keywords.slice(0, 6)
        } else if (row.Keywords && Array.isArray(row.Keywords)) {
            temp = row.Keywords.slice(0, 6)
        } else if (row.fsai_keyword && Array.isArray(row.fsai_keyword)) {
            temp = row.fsai_keyword.slice(0, 6)
        } else if (row.keyword && Array.isArray(row.keyword)) {
            temp = row.keyword.slice(0, 6)
        } else if (row.keywords && Array.isArray(row.keywords)) {
            temp = row.keywords.slice(0, 6)
        }

        // Extract content text safely
        const contentText = extractText(row.Body || row.body || row.text || row.content) || "No content available"

        // Handle case where sentiment score exists - similar to news structure
        // Note: We check for null/undefined explicitly so that 0 (neutral) is treated as valid
        if (sentimentScore !== null && sentimentScore !== undefined) {
            return (
                <div
                    className='pl-3 pb-0 mb-2'
                    style={{
                        borderLeft: quickBorder(sentimentScore || 0),
                        paddingLeft: 10
                    }}>
                    {temp && temp.length > 0 && (
                        <h5
                            style={{
                                fontWeight: 700,
                                color: "rgb(0, 99, 158)",
                                marginBottom: 3
                            }}>
                            {temp.map((word) => {
                                if (typeof word === 'string') return word
                                if (typeof word === 'object' && word !== null) return word.text || word.Text || ''
                                return ''
                            }).filter(w => w).join(" ")}
                        </h5>
                    )}
                    <a
                        style={{
                            marginBottom: 3,
                            fontSize: 20,
                            color: "black",
                            textDecoration: "none"
                        }}>
                        {contentText}
                    </a>
                    <br></br>
                    <br></br>
                    <div
                        className='row mt-1'
                        style={{ fontSize: 16, color: "rgb(200, 154, 93)" }}>
                        <p className='col-4'>
                            {(row.Created_at2 || row.created_at || row.date || row.Created_at) + "(ET)"}
                        </p>
                        <p className='col-4 ml-auto mr-auto'>
                            <b>Relevance: </b>
                            {row.rev_score ? row.rev_score.toFixed(3) : "N/A"}
                        </p>
                        <div className='col-4 ml-auto'>
                            <p>
                                <b>Sentiment score:</b>{" "}
                                {typeof sentimentScore === 'number' ? sentimentScore.toFixed(3) : sentimentScore}
                            </p>
                        </div>
                    </div>
                </div>
            )
        } 
        // Handle case where no sentiment score is available - similar to news fallback
        // Default to neutral (yellow) border when sentiment is unavailable
        else {
            return (
                <div className='pl-3 pb-0 mb-2' style={{ 
                    borderLeft: quickBorder(0),
                    paddingLeft: 10 
                }}>
                    {temp && temp.length > 0 && (
                        <h5
                            style={{
                                fontWeight: 700,
                                color: "rgb(0, 99, 158)",
                                marginBottom: 3
                            }}>
                            {temp.map((word) => {
                                if (typeof word === 'string') return word
                                if (typeof word === 'object' && word !== null) return word.text || word.Text || ''
                                return ''
                            }).filter(w => w).join(" ")}
                        </h5>
                    )}
                    <a
                        style={{
                            marginBottom: 3,
                            fontSize: 20,
                            color: "black",
                            textDecoration: "none"
                        }}>
                        {contentText}
                    </a>
                    <br></br>
                    <br></br>
                    <div
                        className='row mt-1'
                        style={{ fontSize: 16, color: "rgb(200, 154, 93)" }}>
                        <p className='col-4'>
                            {(row.Created_at2 || row.created_at || row.date || row.Created_at) + "(ET)"}
                        </p>
                        <p className='col-4 ml-auto mr-auto'>
                            <b>Relevance: </b>
                            {row.rev_score ? row.rev_score.toFixed(3) : "N/A"}
                        </p>
                        <div className='col-4 ml-auto'>
                            <p>
                                <b>Sentiment score:</b> --
                            </p>
                        </div>
                    </div>
                </div>
            )
        }
    }

    const getReddit = () => {
        let rows = (
            <h5 style={{ color: "#adb5bd" }}>Run a Query to Load Data</h5>
        )
        try {
            if (
                redditList &&
                redditList.title &&
                redditList.title.data &&
                redditList.title.data.length > 0
            ) {
                const maxItems = 600
                const limitedData = redditList.title.data.slice(0, maxItems)
                const startIndex = (redditCurrentPage - 1) * itemsPerPage
                const endIndex = startIndex + itemsPerPage
                const paginatedData = limitedData.slice(startIndex, endIndex)
                
                rows = paginatedData
                    .map(redditTableVals)
                    .filter(row => row !== null)
            }
        } catch (err) {
            console.log(err)
        }

        return <div>{rows}</div>
    }

    const blueskyTableVals = (row) => {
        if (!row) return null
        return (
            <div
                className='pl-3 pb-0 mb-2'
                style={{
                    borderLeft: quickBorder(parseFloat(row[props.DQToggle])),
                    paddingLeft: 10
                }}>
                {row.Keyword && row.Keyword.length > 0 && (
                    <h5
                        style={{
                            fontWeight: 700,
                            color: "rgb(0, 99, 158)",
                            marginBottom: 3
                        }}>
                        {row.Keyword.map((word) => word.text).join(" ")}
                    </h5>
                )}
                <p
                    style={{
                        marginBottom: 3,
                        fontSize: 20,
                        color: "black",
                        textDecoration: "none"
                    }}>
                    {row.post_text}
                </p>
                <br></br>
                <br></br>
                <div
                    className='row mt-1'
                    style={{ fontSize: 16, color: "rgb(200, 154, 93)" }}>
                    <p className='col-4'>{row.Created_at2 + "(ET)"}</p>
                    <p className='col-4 ml-auto mr-auto'>
                        <b>Relevance: </b>
                        {row.rev_score.toFixed(3)}
                    </p>
                    {row.Sentiment_score && (
                        <div className='col-4 ml-auto'>
                            <p>
                                <b>Sentiment score:</b>{" "}
                                {row.Sentiment_score.toFixed(3)}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    const getBluesky = () => {
        let rows = (
            <h5 style={{ color: "#adb5bd" }}>Run a Query to Load Data</h5>
        )
        try {
            if (
                blueskyList &&
                blueskyList.title &&
                blueskyList.title.data &&
                blueskyList.title.data.length > 0
            ) {
                const maxItems = 600
                const limitedData = blueskyList.title.data.slice(0, maxItems)
                const startIndex = (blueskyCurrentPage - 1) * itemsPerPage
                const endIndex = startIndex + itemsPerPage
                const paginatedData = limitedData.slice(startIndex, endIndex)
                
                rows = paginatedData
                    .map(blueskyTableVals)
                    .filter(row => row !== null)
            }
        } catch (err) {
            console.log(err)
        }

        return <div>{rows}</div>
    }

    const edgarTableVals = (row) => {
        if (!row) return null

        return (
            <div
                className='pl-3 pb-0 mb-2'
                style={{
                    paddingLeft: 10
                }}>
                {row.ticker && (
                    <h5
                        style={{
                            fontWeight: 700,
                            color: "rgb(0, 99, 158)",
                            marginBottom: 3
                        }}>
                        {row.ticker} | {row.report_type} |{" "}
                        <a
                            href={row.report_link}
                            target='_blank'
                            className='text-black'>
                            Link
                        </a>
                    </h5>
                )}
                <div
                    className='row mt-1'
                    style={{ fontSize: 16, color: "rgb(200, 154, 93)" }}>
                    <b className='col-4'>{row.filed_at + "(ET)"}</b>
                    <p className='col-4 ml-auto mr-auto'>
                        <b>Relevance: </b>
                        {row.rev_score.toFixed(3)}
                    </p>
                    {row.fsai_sentiment_score && (
                        <div className='col-4 ml-auto'>
                            <p>
                                <b>Sentiment score:</b>{" "}
                                {row.fsai_sentiment_score}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    const getEdgar = () => {
        let rows = (
            <h5 style={{ color: "#adb5bd" }}>Run a Query to Load Data</h5>
        )
        try {
            if (
                edgarList &&
                edgarList.title &&
                edgarList.title.data &&
                edgarList.title.data.length > 0
            ) {
                const maxItems = 600
                const limitedData = edgarList.title.data.slice(0, maxItems)
                const startIndex = (edgarCurrentPage - 1) * itemsPerPage
                const endIndex = startIndex + itemsPerPage
                const paginatedData = limitedData.slice(startIndex, endIndex)
                
                rows = paginatedData
                    .map(edgarTableVals)
                    .filter(row => row !== null)
            }
        } catch (err) {
            console.log(err)
        }

        return <div>{rows}</div>
    }

    const newsTableVals = (row) => {
        // Add safety checks for required properties
        if (!row || !row.Created_at || !row.rev_score) {
            console.warn("Missing required properties in row:", row)
            return null
        }

        // Helper function to safely extract text from potentially nested objects
        const extractText = (value) => {
            if (value === null || value === undefined) return null
            if (typeof value === 'string') return value
            if (typeof value === 'object') {
                // Try common text properties
                return value.text || value.Text || value.content || value.Content || 
                       value.body || value.Body || value.message || value.Message ||
                       JSON.stringify(value) // Last resort
            }
            return String(value)
        }

        // Determine sentiment score based on available properties - check all possible combinations
        let sentimentScore = null
        if (props.newsToggle === "title") {
            // For title mode, check all possible sentiment score properties
            sentimentScore = row[props.DQToggle] || 
                            row.fsai_sentiment_score || 
                            row.sentiment_score || 
                            row.Sentiment_score ||
                            row.fsai_Sentiment_score
        } else {
            // For text mode, check text-specific sentiment scores
            sentimentScore = row[props.DQToggle + "_text"] || 
                            row.fsai_sentiment_score_text || 
                            row.sentiment_score_text || 
                            row.Sentiment_score_text ||
                            row.fsai_Sentiment_score_text
        }

        // If still null, try the base properties as fallback
        if (sentimentScore === null || sentimentScore === undefined) {
            sentimentScore = row.fsai_sentiment_score || 
                            row.sentiment_score || 
                            row.Sentiment_score ||
                            row.fsai_Sentiment_score
        }

        // Determine keyword based on available properties
        let temp = null
        if (row.fsai_Keyword && Array.isArray(row.fsai_Keyword)) {
            temp = row.fsai_Keyword.slice(0, 6)
        } else if (row.Keyword && Array.isArray(row.Keyword)) {
            temp = row.Keyword.slice(0, 6)
        } else if (row.fsai_keyword && Array.isArray(row.fsai_keyword)) {
            temp = row.fsai_keyword.slice(0, 6)
        }

        // Extract content text safely
        const contentText = extractText(row.Body) || "No content available"

        // Handle case where sentiment score exists
        // Note: We check for null/undefined explicitly so that 0 (neutral) is treated as valid
        if (sentimentScore !== null && sentimentScore !== undefined) {
            return (
                <div
                    className='pl-3 pb-0 mb-2'
                    style={{
                        borderLeft: quickBorder(sentimentScore || 0),
                        paddingLeft: 10
                    }}>
                    <a
                        href={row.url}
                        target='_blank'
                        style={{ textDecoration: "none" }}>
                        <h5
                            style={{
                                fontWeight: 700,
                                color: "rgb(0, 99, 158)",
                                marginBottom: 3
                            }}>
                            {temp
                                ? temp.map((word) => word.text).join(" ")
                                : ""}
                        </h5>
                    </a>
                    <a
                        style={{
                            marginBottom: 3,
                            fontSize: 20,
                            color: "black"
                        }}>
                        {contentText}
                    </a>
                    <br></br>
                    <br></br>
                    <div
                        className='row mt-1'
                        style={{ fontSize: 16, color: "rgb(200, 154, 93)" }}>
                        <p className='col-4'>
                            {row.Created_at.replace("T", " ").replace("Z", "") +
                                "(ET)"}
                        </p>
                        <p className='col-4 ml-auto mr-auto'>
                            <b>Relevance: </b>
                            {row.rev_score ? row.rev_score.toFixed(3) : "N/A"}
                        </p>
                        <div className='col-4 ml-auto'>
                            <p>
                                <b>Sentiment score:</b>{" "}
                                {typeof sentimentScore === 'number' ? sentimentScore.toFixed(3) : sentimentScore}
                            </p>
                        </div>
                    </div>
                </div>
            )
        } 
        // Handle case where no sentiment score is available
        // Default to neutral (yellow) border when sentiment is unavailable
        else {
            return (
                <div className='pl-3 pb-0 mb-2' style={{ 
                    borderLeft: quickBorder(0),
                    paddingLeft: 10 
                }}>
                    <a
                        href={row.url}
                        target='_blank'
                        style={{ textDecoration: "none" }}>
                        <h5
                            style={{
                                fontWeight: 700,
                                color: "rgb(0, 99, 158)",
                                marginBottom: 3
                            }}>
                            {temp
                                ? temp.map((word) => word.text).join(" ")
                                : ""}
                        </h5>
                    </a>
                    <a
                        style={{
                            marginBottom: 3,
                            fontSize: 20,
                            color: "black"
                        }}>
                        {contentText}
                    </a>
                    <br></br>
                    <br></br>
                    <div
                        className='row mt-1'
                        style={{ fontSize: 16, color: "rgb(200, 154, 93)" }}>
                        <p className='col-4'>
                            {row.Created_at.replace("T", " ").replace("Z", "") +
                                "(ET)"}
                        </p>
                        <p className='col-4 ml-auto mr-auto'>
                            <b>Relevance: </b>
                            {row.rev_score ? row.rev_score.toFixed(3) : "N/A"}
                        </p>
                        <div className='col-4 ml-auto'>
                            <p>
                                <b>Sentiment score:</b> --
                            </p>
                        </div>
                    </div>
                </div>
            )
        }
    }

    const getNews = () => {
        let rows = (
            <h5 style={{ color: "#adb5bd" }}>Run a Query to Load Data</h5>
        )
        try {
            if (newsList && typeof newsList === 'object') {
                if (props.newsToggle === "text") {
                    console.log("Rendering text data, count:", newsList.text?.data?.length || 0)
                    if (newsList.text && newsList.text.data && newsList.text.data.length > 0) {
                        // Limit to maximum 600 items
                        const limitedData = newsList.text.data.slice(0, 600)
                        const startIndex = (newsCurrentPage - 1) * itemsPerPage
                        const endIndex = startIndex + itemsPerPage
                        const paginatedData = limitedData.slice(startIndex, endIndex)
                        
                        console.log(`Showing items ${startIndex + 1}-${Math.min(endIndex, limitedData.length)} of ${limitedData.length} (limited from ${newsList.text.data.length})`)
                        
                        rows = paginatedData
                            .map((row, pos) => newsTableVals(row))
                            .filter(row => row !== null)
                    }
                } else {
                    console.log("Rendering title data, count:", newsList.title?.data?.length || 0)
                    if (newsList.title && newsList.title.data && newsList.title.data.length > 0) {
                        // Limit to maximum 600 items
                        const limitedData = newsList.title.data.slice(0, 600)
                        const startIndex = (newsCurrentPage - 1) * itemsPerPage
                        const endIndex = startIndex + itemsPerPage
                        const paginatedData = limitedData.slice(startIndex, endIndex)
                        
                        console.log(`Showing items ${startIndex + 1}-${Math.min(endIndex, limitedData.length)} of ${limitedData.length} (limited from ${newsList.title.data.length})`)
                        
                        rows = paginatedData
                            .map((row, pos) => newsTableVals(row))
                            .filter(row => row !== null)
                    }
                }
            }
        } catch (err) {
            console.error("Error in getNews:", err)
        }

        return <div>{rows}</div>
    }

    // Pagination helper functions
    const getNewsTotalPages = () => {
        const maxItems = 600 // Hard limit
        if (props.newsToggle === "text") {
            const totalItems = Math.min(newsList.text?.data?.length || 0, maxItems)
            return Math.ceil(totalItems / itemsPerPage)
        } else {
            const totalItems = Math.min(newsList.title?.data?.length || 0, maxItems)
            return Math.ceil(totalItems / itemsPerPage)
        }
    }

    const getStTotalPages = () => {
        const maxItems = 600
        const totalItems = Math.min(stList.title?.data?.length || 0, maxItems)
        return Math.ceil(totalItems / itemsPerPage)
    }

    const getRedditTotalPages = () => {
        const maxItems = 600
        const totalItems = Math.min(redditList.title?.data?.length || 0, maxItems)
        return Math.ceil(totalItems / itemsPerPage)
    }

    const getBlueskyTotalPages = () => {
        const maxItems = 600
        const totalItems = Math.min(blueskyList.title?.data?.length || 0, maxItems)
        return Math.ceil(totalItems / itemsPerPage)
    }

    const getEdgarTotalPages = () => {
        const maxItems = 600
        const totalItems = Math.min(edgarList.title?.data?.length || 0, maxItems)
        return Math.ceil(totalItems / itemsPerPage)
    }

    // Pagination render functions
    const renderNewsPagination = () => {
        const totalPages = getNewsTotalPages()
        if (totalPages <= 1) return null

        const maxItems = 600
        const actualDataLength = props.newsToggle === "text" 
            ? (newsList.text?.data?.length || 0)
            : (newsList.title?.data?.length || 0)
        
        const displayedDataLength = Math.min(actualDataLength, maxItems)

        return (
            <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                padding: '10px 20px',
                borderTop: '1px solid #e0e0e0'
            }}>
                <div style={{ fontSize: '14px', color: 'rgb(200, 154, 93)' }}>
                    Sorted by {sortNews || 'Relevance'} ↓ | Showing: {displayedDataLength} items 
                </div>
                <Pagination 
                    count={totalPages}
                    page={newsCurrentPage}
                    onChange={handleNewsPageChange}
                    color="primary"
                    size="small"
                    showFirstButton
                    showLastButton
                />
            </div>
        )
    }

    const renderStPagination = () => {
        const totalPages = getStTotalPages()
        if (totalPages <= 1) return null

        const maxItems = 600
        const actualDataLength = stList.title?.data?.length || 0
        const displayedDataLength = Math.min(actualDataLength, maxItems)

        return (
            <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                padding: '10px 20px',
                borderTop: '1px solid #e0e0e0'
            }}>
                <div style={{ fontSize: '14px', color: 'rgb(200, 154, 93)' }}>
                    Sorted by {sortST || 'Relevance'} ↓ | Showing: {displayedDataLength} items 
                </div>
                <Pagination 
                    count={totalPages}
                    page={stCurrentPage}
                    onChange={handleStPageChange}
                    color="primary"
                    size="small"
                    showFirstButton
                    showLastButton
                />
            </div>
        )
    }

    const renderRedditPagination = () => {
        const totalPages = getRedditTotalPages()
        if (totalPages <= 1) return null

        const maxItems = 600
        const actualDataLength = redditList.title?.data?.length || 0
        const displayedDataLength = Math.min(actualDataLength, maxItems)

        return (
            <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                padding: '10px 20px',
                borderTop: '1px solid #e0e0e0'
            }}>
                <div style={{ fontSize: '14px', color: 'rgb(200, 154, 93)' }}>
                    Sorted by {sortReddit || 'Relevance'} ↓ | Showing: {displayedDataLength} items 
                </div>
                <Pagination 
                    count={totalPages}
                    page={redditCurrentPage}
                    onChange={handleRedditPageChange}
                    color="primary"
                    size="small"
                    showFirstButton
                    showLastButton
                />
            </div>
        )
    }

    const renderBlueskyPagination = () => {
        const totalPages = getBlueskyTotalPages()
        if (totalPages <= 1) return null

        const maxItems = 600
        const actualDataLength = blueskyList.title?.data?.length || 0
        const displayedDataLength = Math.min(actualDataLength, maxItems)

        return (
            <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                padding: '10px 20px',
                borderTop: '1px solid #e0e0e0'
            }}>
                <div style={{ fontSize: '14px', color: 'rgb(200, 154, 93)' }}>
                    Sorted by {sortBluesky || 'Relevance'} ↓ | Showing: {displayedDataLength} items 
                </div>
                <Pagination 
                    count={totalPages}
                    page={blueskyCurrentPage}
                    onChange={handleBlueskyPageChange}
                    color="primary"
                    size="small"
                    showFirstButton
                    showLastButton
                />
            </div>
        )
    }

    const renderEdgarPagination = () => {
        const totalPages = getEdgarTotalPages()
        if (totalPages <= 1) return null

        const maxItems = 600
        const actualDataLength = edgarList.title?.data?.length || 0
        const displayedDataLength = Math.min(actualDataLength, maxItems)

        return (
            <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                padding: '10px 20px',
                borderTop: '1px solid #e0e0e0'
            }}>
                <div style={{ fontSize: '14px', color: 'rgb(200, 154, 93)' }}>
                    Sorted by {sortEdgar || 'Relevance'} ↓ | Showing: {displayedDataLength} items 
                </div>
                <Pagination 
                    count={totalPages}
                    page={edgarCurrentPage}
                    onChange={handleEdgarPageChange}
                    color="primary"
                    size="small"
                    showFirstButton
                    showLastButton
                />
            </div>
        )
    }

    // Download functions
    const downloadNews = async () => {
        props.query["not"] = false
        let raw = { query: props.query, key: "prod" }
        axios
            .post(
                `${
                    process.env.REACT_APP_API_HOST ||
                    "https://25becp9ef3.execute-api.ap-south-1.amazonaws.com/dev"
                }/download-data`,
                raw,
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*/*",
                        "Content-Type": "application/json"
                    }
                }
            )
            .then((result) => {
                // result = JSON.parse(result);
                window.open(result.data["news_link"])
            })
            .catch((error) => {
                console.log("error", error.response.data)
            })
        return true
    }

    const downloadStocktwits = async () => {
        props.query["not"] = false
        let raw = { query: props.query, key: "prod" }
        axios
            .post(
                `${
                    process.env.REACT_APP_API_HOST ||
                    "https://25becp9ef3.execute-api.ap-south-1.amazonaws.com/dev"
                }/download-data`,
                raw,
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*/*",
                        "Content-Type": "application/json"
                    }
                }
            )
            .then((result) => {
                // result = JSON.parse(result);
                window.open(result.data["stocktwits_link"])
            })
            .catch((error) => {
                console.log("error", error.response, error)
            })
        return true
    }

    const downloadReddit = async () => {
        props.query["not"] = false
        let raw = { query: props.query, key: "prod" }
        axios
            .post(
                `${
                    process.env.REACT_APP_API_HOST ||
                    "https://25becp9ef3.execute-api.ap-south-1.amazonaws.com/dev"
                }/download-data`,
                raw,
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*/*",
                        "Content-Type": "application/json"
                    }
                }
            )
            .then((result) => {
                // result = JSON.parse(result);
                window.open(result.data["reddit_link"])
            })
            .catch((error) => {
                console.log("error", error.response, error)
            })
        return true
    }

    const downloadBluesky = async () => {
        props.query["not"] = false
        let raw = { query: props.query, key: "prod" }
        axios
            .post(
                `${
                    process.env.REACT_APP_API_HOST ||
                    "https://25becp9ef3.execute-api.ap-south-1.amazonaws.com/dev"
                }/download-data`,
                raw,
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*/*",
                        "Content-Type": "application/json"
                    }
                }
            )
            .then((result) => {
                window.open(result.data["bluesky_link"])
            })
            .catch((error) => {
                console.log("error", error.response, error)
            })
        return true
    }

    const downloadEdgar = async () => {
        props.query["not"] = false
        let raw = { query: props.query, key: "prod", edgar_flag: true }
        axios
            .post(
                `${
                    process.env.REACT_APP_API_HOST ||
                    "https://25becp9ef3.execute-api.ap-south-1.amazonaws.com/dev"
                }/download-data`,
                raw,
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*/*",
                        "Content-Type": "application/json"
                    }
                }
            )
            .then((result) => {
                window.open(result.data["edgar_link"])
            })
            .catch((error) => {
                console.log("error", error.response, error)
            })
        return true
    }


    // Scroll data loading function
    const loadScrollData = async (scrollId, source, maxAttempts = 3) => {
        if (!scrollId) return

        setIsLoadingScroll(true)
        setScrollLoadingComplete(false)
        let attempts = 0
        let totalLoadedCount = 0
        let currentScrollId = scrollId

        while (attempts < maxAttempts) {
            try {                
                const scrollResponse = await api.get_scroll_data(currentScrollId)
                if (scrollResponse && scrollResponse.data) {
                    const newData = scrollResponse.data
                    const dataCount = newData.length || 0
                    
                    totalLoadedCount += dataCount
                    
                    if (dataCount > 0) {
                        if (source === "news") {
                            if (props.newsToggle === "title") {
                                setNewsList(prevList => {
                                    const updatedList = {
                                        ...prevList,
                                        title: {
                                            ...prevList.title,
                                            data: [...(prevList.title?.data || []), ...newData]
                                        }
                                    }
                                    console.log("Updated news title data count:", updatedList.title.data.length)
                                    return updatedList
                                })
                            } else if (props.newsToggle === "text") {
                                setNewsList(prevList => {
                                    const updatedList = {
                                        ...prevList,
                                        text: {
                                            ...prevList.text,
                                            data: [...(prevList.text?.data || []), ...newData]
                                        }
                                    }
                                    console.log("Updated news text data count:", updatedList.text.data.length)
                                    return updatedList
                                })
                            }
                        } else if (source === "reddit") {
                            setRedditList(prevList => {
                                const currentData = prevList?.title?.data || []
                                const updatedList = {
                                    ...prevList,
                                    title: {
                                        ...prevList.title,
                                        data: [...currentData, ...newData]
                                    }
                                }
                                console.log("Updated reddit data count:", updatedList.title.data.length)
                                return updatedList
                            })
                        }
                        
                        // Update scroll ID for next request
                        if (scrollResponse.scroll_id) {
                            currentScrollId = scrollResponse.scroll_id
                        } else {
                            console.log(`No more scroll_id returned for ${source}, stopping`)
                            break
                        }
                        
                        // For Reddit, check if we have enough data for at least 2 pages (200 items)
                        if (source === "reddit") {
                            // We need to check the current state, not the old state
                            if (totalLoadedCount >= 100 || attempts >= 2) {
                                console.log(`Reddit loaded ${totalLoadedCount} additional items, stopping`)
                                break
                            }
                        }
                    } else {
                        console.log(`No more data available from scroll for ${source}`)
                        break
                    }
                    
                    attempts++
                } else {
                    console.log(`No data returned from scroll API for ${source}`)
                    break
                }
            } catch (error) {
                console.error(`Error during scroll attempt ${attempts + 1} for ${source}:`, error)
                // If we get a 410 error or similar, stop trying
                if (error.response?.status === 410 || error.response?.status === 404) {
                    console.log(`Scroll context expired for ${source}, stopping`)
                    break
                }
                attempts++
                // Wait a bit before retrying
                await new Promise(resolve => setTimeout(resolve, 1000))
            }
        }
        

        setIsLoadingScroll(false)
        setScrollLoadingComplete(true)
    }

    // useEffect hooks
    useEffect(() => {
        if (scrollLoadingComplete) {
            console.log("Scroll loading completed, UI will refresh")
            const timer = setTimeout(() => {
                setScrollLoadingComplete(false)
            }, 100)
            
            return () => clearTimeout(timer)
        }
    }, [scrollLoadingComplete])

    useEffect(() => {
        if (props.newsData != []) {
            setNewsList((t) => {
                return props.newsData.data
            })
            setNewsValues()
            
            let scrollId = null
            if (props.newsToggle === "title") {
                scrollId = props.newsData.data?.title?.scroll_id
            } else {
                scrollId = props.newsData.data?.text?.scroll_id
            }
            
            if (scrollId) {
                console.log("News scroll ID found, loading additional data...", scrollId)
                loadScrollData(scrollId, "news")
            }
        } else {
            setNewsList((t) => {
                return []
            })
        }

        if (props.stocktwitsData != []) {
            setStList((t) => {
                return props.stocktwitsData.data
            })
            setSTValues()
        } else {
            setStList((t) => {
                return []
            })
        }

        if (props.redditData != []) {
            setRedditList((t) => {
                return props.redditData.data
            })
            setRedditValues()
            
            // Check for Reddit scroll ID
            let redditScrollId = props.redditData.data?.title?.scroll_id
            if (redditScrollId) {
                console.log("Reddit scroll ID found, loading additional data...", redditScrollId)
                loadScrollData(redditScrollId, "reddit")
            }
        } else {
            setRedditList((t) => {
                return []
            })
        }

        if (props.blueskyData != []) {
            setBlueskyList((t) => {
                return props.blueskyData.data
            })
            setBlueskyValues()
        }

        if (props.edgarData != []) {
            setEdgarList((t) => {
                return props.edgarData.data
            })
            setEdgarValues()
        } else {
            setEdgarList([])
        }
    }, [props])

    useEffect(() => {
        if (newsList && newsList.title && newsList.title.data) {
            console.log("Title data count:", newsList.title.data.length)
        }
        if (newsList && newsList.text && newsList.text.data) {
            console.log("Text data count:", newsList.text.data.length)
        }
    }, [newsList])

    useEffect(() => {
        if (redditList && redditList.title && redditList.title.data) {
            console.log("Reddit data count:", redditList.title.data.length)
        }
    }, [redditList])

    try {
        return (
            <React.Fragment>
                <div className='container-fluid'>
                    <div className='row justify-content-center'>
                        <Snackbar
                            anchorOrigin={{ vertical, horizontal }}
                            open={alertOpen}
                            onClose={handleAlertClose}
                            autoHideDuration={5000}
                            key={vertical + horizontal}
                            severity='error'
                            bodyStyle={{
                                backgroundColor: "teal",
                                color: "coral"
                            }}>
                            <SnackbarContent
                                message={alertState.message}
                                style={
                                    alertState.contentStyle
                                }></SnackbarContent>
                        </Snackbar>
                        
                        {/* Stocktwits Table */}
                        {stList && stList.title && stList.title.data.length > 0 && (
                            <Table
                                sourceName={"Stocktwits"}
                                sourceLogo={stLogo}
                                anchorElSource={anchorElST}
                                selectedSourceIndex={selectedIndexST}
                                sourceCount={stCount}
                                handleClosePopup={handleCloseST}
                                handleMenuSource={handleMenuST}
                                setSortSource={setSortST}
                                getSortData={getSortData}
                                downloadSource={downloadStocktwits}
                                getSource={getStocktwits}
                                renderPagination={renderStPagination}
                            />
                        )}

                        {/* News Table */}
                        {newsList && (
                            (props.newsToggle === "text" && newsList.text && newsList.text.data && newsList.text.data.length > 0) ||
                            (props.newsToggle === "title" && newsList.title && newsList.title.data && newsList.title.data.length > 0)
                        ) && (
                            <div className='col-md-6 mb-3'>
                                <Card
                                    style={{
                                        width: "100%",
                                        border: "1px solid #919191",
                                        boxShadow: "1px 1px 7px 1px lightgrey",
                                        borderRadius: 10,
                                        backgroundColor: "#f4f4f4",
                                        height: "100%",
                                        maxHeight: "90vh",
                                        display: "flex",
                                        flexDirection: "column"
                                    }}>
                                    <CardHeader
                                        avatar={
                                            <img
                                                src={newsLogo}
                                                alt=''
                                                height={60}
                                                width={33}></img>
                                        }
                                        title={
                                            <div className='d-flex'>
                                                <h3
                                                    style={{
                                                        fontWeight: 600,
                                                        marginTop: 2,
                                                        color: "rgb(68,68,68)",
                                                        fontFamily: "Verdana, Arial"
                                                }}>
                                                News
                                                </h3>
                                                <Tooltip
                                                    arrow
                                                    title={<h6>To sort the table below</h6>}
                                                    placement='top'>
                                                    <div
                                                        className='sorting-step'
                                                        style={{
                                                            marginLeft: "auto",
                                                            marginRight: "0",
                                                            height: 50,
                                                            marginTop: -4
                                                        }}>
                                                        <IconButton
                                                            aria-controls='simple-menu'
                                                            aria-haspopup='true'
                                                            color='inherit'
                                                            aria-label='Person'
                                                            onClick={handleMenuNews}>
                                                            <FilterListIcon />
                                                        </IconButton>
                                                        <Menu
                                                            id='simple-menu'
                                                            keepMounted
                                                            anchorEl={anchorElNews}
                                                            anchorOrigin={{
                                                                vertical: "top",
                                                                horizontal: "right"
                                                            }}
                                                            open={Boolean(anchorElNews)}
                                                            onClose={handleCloseNews}>
                                                            <MenuItem
                                                                selected={0 === selectedIndexNews}
                                                                onClick={() => {
                                                                    setSortNews("Relevance")
                                                                    getSortData("News", "Relevance")
                                                                    handleCloseNews()
                                                                }}>
                                                                Relevance
                                                            </MenuItem>
                                                            <MenuItem
                                                                selected={1 === selectedIndexNews}
                                                                onClick={() => {
                                                                    setSortNews("Date")
                                                                    getSortData("News", "Date")
                                                                    handleCloseNews()
                                                                }}>
                                                                Date
                                                            </MenuItem>
                                                            <MenuItem
                                                                selected={2 === selectedIndexNews}
                                                                onClick={() => {
                                                                    setSortNews("Sentiment")
                                                                    getSortData("News", "Sentiment")
                                                                    handleCloseNews()
                                                                }}>
                                                                Sentiment Score
                                                            </MenuItem>
                                                        </Menu>
                                                    </div>
                                                </Tooltip>
                                                <Tooltip
                                                    arrow
                                                    title={<h6>Click to download complete News data</h6>}
                                                    placement='top'>
                                                <IconButton
                                                    className='tenth-step'
                                                    color='inherit'
                                                    onClick={downloadNews}
                                                    style={{
                                                        marginRight: "1%",
                                                        height: 50,
                                                        marginTop: -4
                                                    }}>
                                                    <GetAppIcon />
                                                </IconButton>
                                                </Tooltip>
                                                <Tooltip
                                                    arrow
                                                    title={<h6>P-Positive, Nu-Neutral, N-Negative and T-Total</h6>}
                                                    placement='top'>
                                                    <span
                                                        className='eight-step'
                                                        style={{
                                                            marginRight: "3%",
                                                            fontSize: 22,
                                                            fontWeight: 600,
                                                            marginTop: 2,
                                                            color: "rgb(68,68,68)",
                                                            fontFamily: "Verdana, Arial"
                                                        }}>
                                                        P: {newsCount.positive} Nu: {newsCount.neutral} N: {newsCount.negative} T: {newsCount.total}
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        }
                                        style={{
                                            marginTop: 12,
                                            marginLeft: 25
                                        }}
                                    />
                                    <CardContent
                                        className='ninth-step'
                                        style={{
                                            overflowY: "scroll",
                                            height: "100%",
                                            overflowX: "hidden",
                                            marginRight: "20px",
                                            marginLeft: "20px",
                                            paddingBottom: "0",
                                            flex: 1
                                        }}>
                                        {getNews()}
                                    </CardContent>
                                    {renderNewsPagination()}
                                </Card>
                            </div>
                        )}

                        {/* Reddit Table */}
                        {redditList && redditList.title && redditList.title.data.length > 0 && (
                            <div className='col-md-6 mb-3'>
                                <Card
                                    style={{
                                        width: "100%",
                                        border: "1px solid #919191",
                                        boxShadow: "1px 1px 7px 1px lightgrey",
                                        borderRadius: 10,
                                        backgroundColor: "#f4f4f4",
                                        height: "100%",
                                        maxHeight: "90vh",
                                        display: "flex",
                                        flexDirection: "column"
                                    }}>
                                    <CardHeader
                                        avatar={
                                            <img
                                                src={redditLogo}
                                                alt=''
                                                height={60}
                                                width={33}></img>
                                        }
                                        title={
                                            <div className='d-flex'>
                                                <h3
                                                    style={{
                                                        fontWeight: 600,
                                                        marginTop: 2,
                                                        color: "rgb(68,68,68)",
                                                        fontFamily: "Verdana, Arial"
                                                }}>
                                                Reddit
                                                </h3>
                                                <Tooltip
                                                    arrow
                                                    title={<h6>To sort the table below</h6>}
                                                    placement='top'>
                                                    <div
                                                        className='sorting-step'
                                                        style={{
                                                            marginLeft: "auto",
                                                            marginRight: "0",
                                                            height: 50,
                                                            marginTop: -4
                                                        }}>
                                                        <IconButton
                                                            aria-controls='simple-menu'
                                                            aria-haspopup='true'
                                                            color='inherit'
                                                            aria-label='Person'
                                                            onClick={handleMenuReddit}>
                                                            <FilterListIcon />
                                                        </IconButton>
                                                        <Menu
                                                            id='simple-menu'
                                                            keepMounted
                                                            anchorEl={anchorElReddit}
                                                            anchorOrigin={{
                                                                vertical: "top",
                                                                horizontal: "right"
                                                            }}
                                                            open={Boolean(anchorElReddit)}
                                                            onClose={handleCloseReddit}>
                                                            <MenuItem
                                                                selected={0 === selectedIndexReddit}
                                                                onClick={() => {
                                                                    setSortReddit("Relevance")
                                                                    getSortData("Reddit", "Relevance")
                                                                    handleCloseReddit()
                                                                }}>
                                                                Relevance
                                                            </MenuItem>
                                                            <MenuItem
                                                                selected={1 === selectedIndexReddit}
                                                                onClick={() => {
                                                                    setSortReddit("Date")
                                                                    getSortData("Reddit", "Date")
                                                                    handleCloseReddit()
                                                                }}>
                                                                Date
                                                            </MenuItem>
                                                            <MenuItem
                                                                selected={2 === selectedIndexReddit}
                                                                onClick={() => {
                                                                    setSortReddit("Sentiment")
                                                                    getSortData("Reddit", "Sentiment")
                                                                    handleCloseReddit()
                                                                }}>
                                                                Sentiment Score
                                                            </MenuItem>
                                                        </Menu>
                                                    </div>
                                                </Tooltip>
                                                <Tooltip
                                                    arrow
                                                    title={<h6>Click to download complete Reddit data</h6>}
                                                    placement='top'>
                                                <IconButton
                                                    className='eleventh-step'
                                                    color='inherit'
                                                    onClick={downloadReddit}
                                                    style={{
                                                        marginRight: "1%",
                                                        height: 50,
                                                        marginTop: -4
                                                    }}>
                                                    <GetAppIcon />
                                                </IconButton>
                                                </Tooltip>
                                                <Tooltip
                                                    arrow
                                                    title={<h6>P-Positive, Nu-Neutral, N-Negative and T-Total</h6>}
                                                    placement='top'>
                                                    <span
                                                        style={{
                                                            marginRight: "3%",
                                                            fontSize: 22,
                                                            fontWeight: 600,
                                                            marginTop: 2,
                                                            color: "rgb(68,68,68)",
                                                            fontFamily: "Verdana, Arial"
                                                        }}>
                                                        P: {redditCount.positive} Nu: {redditCount.neutral} N: {redditCount.negative} T: {redditCount.total}
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        }
                                        style={{
                                            marginTop: 12,
                                            marginLeft: 25
                                        }}
                                    />
                                    <CardContent
                                        style={{
                                            overflowY: "scroll",
                                            height: "100%",
                                            overflowX: "hidden",
                                            marginRight: "20px",
                                            marginLeft: "20px",
                                            paddingBottom: "0",
                                            flex: 1
                                        }}>
                                        {getReddit()}
                                    </CardContent>
                                    {renderRedditPagination()}
                                </Card>
                            </div>
                        )}

                        {/* Bluesky Table */}
                        {blueskyList && blueskyList.title && blueskyList.title.data.length > 0 && (
                            <Table
                                sourceName={"Bluesky"}
                                sourceLogo={blueskyLogo}
                                anchorElSource={anchorElBluesky}
                                selectedSourceIndex={selectedIndexBluesky}
                                sourceCount={blueskyCount}
                                handleClosePopup={handleCloseBluesky}
                                handleMenuSource={handleMenuBluesky}
                                setSortSource={setSortBluesky}
                                getSortData={getSortData}
                                downloadSource={downloadBluesky}
                                getSource={getBluesky}
                                renderPagination={renderBlueskyPagination}
                            />
                        )}

                        {/* Edgar Table */}
                        {edgarList && edgarList.title && edgarList.title.data.length > 0 && (
                            <Table
                                sourceName={"Edgar"}
                                sourceLogo={edgarLogo}
                                anchorElSource={anchorElEdgar}
                                selectedSourceIndex={selectedIndexEdgar}
                                sourceCount={edgarCount}
                                handleClosePopup={handleCloseEdgar}
                                handleMenuSource={handleMenuEdgar}
                                setSortSource={setSortEdgar}
                                getSortData={getSortData}
                                downloadSource={downloadEdgar}
                                getSource={getEdgar}
                                renderPagination={renderEdgarPagination}
                            />
                        )}
                    </div>
                </div>
            </React.Fragment>
        )
    } catch (e) {
        return (
            <React.Fragment>
                <div className='container-fluid'>
                    <div className='row justify-content-center'>
                        <div className='col-md-6 mb-3'>
                            <h5>Error loading data. Please try again.</h5>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Tables
